import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { SegundaViaPage } from '@/features/segunda-via/page/SegundaViaPage';

export const Route = createFileRoute('/p/cliente/$slug')({
    component: Component,
    validateSearch: z.object({
        documento: z
            .union([z.number(), z.string()])
            .optional()
            .transform((v) => (v ? v.toString() : undefined)),
    }),
});

function Component() {
    const { slug } = Route.useParams();

    return <SegundaViaPage slug={slug} />;
}
